import { call, put, takeEvery, all } from 'redux-saga/effects';
import { tableConfig } from 'src/settings';
import { IRequestParams, IResponse } from '@dash/apiInstance';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import actionTypes from './actionTypes';
import { IInvoice, ILoadInvoicesPathParams } from './types';
import { LoadInvoicesRequestAction } from './actions.d';
import { logger } from '../../../../../../../helpers/logger';
import notifications from '../../../../../../../redux/notifications/actions';
import { sendRequest } from '../../../../../../../helpers/saga';

const unitsApi = new ApiInstance('clients/:id/invoices');
const subunitsApi = new ApiInstance('subunits/:id/invoices');

function* loadInvoices({ payload }: LoadInvoicesRequestAction<ILoadInvoicesPathParams, {}>) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column = 'due_date',
      order = 'descend',
      filter = '',
      type,
      id,
    } = payload;

    const api = type === 'subUnit' ? subunitsApi : unitsApi;

    const result: IResponse<IInvoice[]> = yield call<any, IRequestParams<ILoadInvoicesPathParams, {}>, string>(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    const isSuccess = result?.status === 200 && result?.data;

    if (isSuccess) {
      yield put(
        actions.loadInvoicesSuccess({
          invoices: result.data,
          total: result.totalCount,
          filteredTotal: result.filteredCount,
          sortableColumns: result.sortableColumns,
        }),
      );
    } else {
      yield put(actions.loadInvoicesError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_INVOICES_REQUEST, loadInvoices)]);
}
